// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--FIE8R","content":"_93444fe79c--content--HJqTX","image":"_93444fe79c--image--Otrck"};